import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isAM, isPM } from '../utils/time';

import {
  Container,
  DateContainer,
  TimeOuterContainer,
  TimeContainer,
  MeridiemContainer,
  SmallButton,
  LargeButton,
  SeparatorText,
} from './Header.styles';
import * as VIEWS from '../constants/views';

const Header = ({ date, openView, onViewChange, onAMClicked, onPMClicked }) => (
  <Container data-testid="header">
    <DateContainer>
      <SmallButton
        data-testid="year-button"
        onClick={() => onViewChange(VIEWS.YEARS)}
        selected={openView === VIEWS.YEARS}
      >
        {date.getFullYear()}
      </SmallButton>
      <LargeButton
        data-testid="calendar-button"
        onClick={() => onViewChange(VIEWS.CALENDAR)}
        selected={openView === VIEWS.CALENDAR}
      >
        {`${moment(date).format('MMM')} ${date.getDate()}`}
      </LargeButton>
    </DateContainer>
    <TimeOuterContainer>
      <TimeContainer>
        <LargeButton
          data-testid="hour-button"
          onClick={() => onViewChange(VIEWS.HOURS)}
          selected={openView === VIEWS.HOURS}
        >
          {moment(date).format('hh')}
        </LargeButton>
        <SeparatorText>:</SeparatorText>
        <LargeButton
          data-testid="minutes-button"
          onClick={() => onViewChange(VIEWS.MINUTES)}
          selected={openView === VIEWS.MINUTES}
        >
          {moment(date).format('mm')}
        </LargeButton>
      </TimeContainer>
      <MeridiemContainer>
        <SmallButton onClick={onAMClicked} selected={isAM(date)}>
          AM
        </SmallButton>
        <SmallButton onClick={onPMClicked} selected={isPM(date)}>
          PM
        </SmallButton>
      </MeridiemContainer>
    </TimeOuterContainer>
  </Container>
);

Header.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  openView: PropTypes.string.isRequired,
  onViewChange: PropTypes.func.isRequired,
  onAMClicked: PropTypes.func.isRequired,
  onPMClicked: PropTypes.func.isRequired,
};

export default React.memo(Header);
